import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon, SuccessIcon, WarningIcon} from 'shells/action-box/action-icons';
import {Button} from 'shells/button/button';
import {Link} from 'shells/link/link';

import type {FromAddress} from '../../drip-sequences/drip-sequence-page/activate-sequence-modal/helpers';

type Props = {
    fromAddress: FromAddress;
    closeModal: () => void;
};

export function FromActionBox(props: Props) {
    const {senderAddress, isSenderVerified, isDmarcVerified} = props.fromAddress;

    let icon =
        senderAddress && isSenderVerified && isDmarcVerified ? <SuccessIcon /> : <ErrorIcon />;

    // We may be allowing it to send anyhow (not enforced) - show as warning
    if (!isDmarcVerified && !NutClientConfig.enforceDmarcSetup) {
        icon = <WarningIcon />;
    }

    return (
        <ActionBox
            title='From'
            subtitle={getFromText(senderAddress, isSenderVerified, isDmarcVerified)}
            icon={icon}
            actionElement={getFromActionElement(
                isSenderVerified,
                senderAddress,
                isDmarcVerified,
                props.closeModal
            )}
        />
    );
}

function getFromText(
    senderAddress: string | null | undefined,
    isSenderVerified: boolean,
    isDmarcVerified: boolean
) {
    if (!senderAddress) {
        return 'Select a sender for this drip sequence';
    }

    if (senderAddress && !isSenderVerified) {
        return 'Your selected sender address hasn’t been verified';
    }

    if (!isDmarcVerified) {
        return 'Set up DMARC records for more reliable email delivery';
    }

    // Sender is verified and address is included
    return senderAddress;
}

function getFromActionElement(
    isSenderVerified: boolean,
    senderAddress: string | null | undefined,
    isDmarcVerified: boolean,
    closeModal: () => void
) {
    if (!senderAddress) {
        return (
            // TODO: Add focus to "from" select on close
            <Button variant='text-primary' size='big' onClick={closeModal}>
                Go to drip sequence details
            </Button>
        );
    }

    // Admins and non-admins can manage sender addresses
    if (!isSenderVerified) {
        return (
            // @ts-expect-error
            <Link variant='primary' to='/email-marketing/sender-address' as={RoutedLink}>
                Manage sender addresses
            </Link>
        );
    }

    if (!isDmarcVerified) {
        return (
            // @ts-expect-error
            <Link variant='primary' to='/setup/domains' as={RoutedLink}>
                Configure
            </Link>
        );
    }
}
